import { Button, Card, Col, Divider, Input, message, Pagination, Row, Spin, Tabs } from "antd";
import React, { useEffect, useState } from "react";

import InsuranceBreakDownPatientContainer from "./InsuranceBreakDownPatientContainer";
import InsuranceBreakDownRequestModal from "./InsuranceBreakDownRequestModal";
import InsuranceBreakDownFilters from "./InsuranceBreakDownFilters";
import InsuranceBreakDownLabel from "./InsuranceBreakDownLabel";

import taskSquareWhite from "../../assets/icons/task-square-white.svg";
import search from "../../assets/icons/search-normal.png";
import refresh from "../../assets/icons/refresh-2.svg";
import archive from "../../assets/icons/archive3.svg";
import filter from "../../assets/icons/filter.svg";

import { controller as treatmentsController } from "../TreatmentPlans/controller";
import { controller } from "../../controller";

export default function InsuranceBreakDownMainPage({ setSelectedBreakdown, selectedBreakdown, setSummaryOfSelectedBreakdown }) {
  const [activeTab, setActiveTab] = useState("all");
  const [showRequestModal, setShowRequestModal] = useState(false);
  const [showFilters, setShowFilters] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [insuranceStatus, setInsuranceStatus] = useState({ received: "", approved: "" });
  const [mySearch, setMySearch] = useState(null);
  const [allPatients, setAllPatients] = useState([]); // All office patients
  const [isGettingPatients, setIsGettingPatients] = useState(false); // Loading for the time that all patients are fetching
  const [allProcedures, setAllProcedures] = useState([]);
  const [isGettingProcedures, setIsGettingProcedures] = useState(false); // Loading for the time that all patients are fetching
  const [isGettingBreakdownPatients, setIsGettingBreakdownPatients] = useState(false); // Loading for the time that all patients are fetching
  const [breakdowns, setBreakdowns] = useState([]);
  const [counter, setCounter] = useState(0);
  const [filterFormData, setFilterFormData] = useState({ patient_ids: undefined, procedure_ids: undefined, expiry_date: "" });
  const [totalBreakdowns, setTotalBreakdonws] = useState(null);

  const children =
    isGettingPatients || isGettingBreakdownPatients || isGettingProcedures ? (
      <Spin />
    ) : (
      <InsuranceBreakDownPatientContainer
        allPatients={allPatients}
        isGettingPatients={isGettingPatients}
        getAllOfficePatients={getAllOfficePatients}
        breakdowns={breakdowns}
        setSelectedBreakdown={setSelectedBreakdown}
        setSummaryOfSelectedBreakdown={setSummaryOfSelectedBreakdown}
        selectedBreakdown={selectedBreakdown}
      />
    );

  const insuranceTabs = [
    { key: "all", label: <p style={{ fontSize: 16 }}>All</p>, children },
    { key: "approved", label: <p style={{ fontSize: 16 }}>Approved</p>, children },
    { key: "pending", label: <p style={{ fontSize: 16 }}>Pending</p>, children },
    { key: "processing", label: <p style={{ fontSize: 16 }}>Processing</p>, children },
  ];

  const getinsuranceStatus = async () => {
    const response = await controller.getInsuranceApprovedReceived();
    setInsuranceStatus(response.json);
  };

  useEffect(() => {
    getinsuranceStatus();
  }, []);

  useEffect(() => {
    getAllBreakdownPatients();
  }, [activeTab, filterFormData, currentPage, counter]);

  useEffect(() => {
    if (!showRequestModal) getAllBreakdownPatients();
  }, [showRequestModal]);

  // Getting all office patients
  useEffect(function () {
    getAllBreakdownPatients();
  }, []);

  // Getting all procedures
  useEffect(function () {
    async function getAllProcedures() {
      try {
        setIsGettingProcedures(true);
        const res = await treatmentsController.getProcedure(0, "");
        setAllProcedures(res.json);
      } catch (err) {
        message.error("Something went wrong while fetching procedures");
        console.error(err);
      } finally {
        setIsGettingProcedures(false);
      }
    }
    getAllProcedures();
  }, []);

  // Getting all office patients
  useEffect(function () {
    getAllOfficePatients();
  }, []);

  async function getAllOfficePatients() {
    try {
      setIsGettingPatients(true);
      const response = await controller.getPatient2();
      setAllPatients(response);
    } catch (err) {
      message.error("Something went wrong while fetching all patients");
      console.error(err);
    } finally {
      setIsGettingPatients(false);
    }
  }

  async function getAllBreakdownPatients() {
    try {
      setIsGettingBreakdownPatients(true);
      const res = await controller.getInsuranceBreakdownsPatients(currentPage, activeTab, filterFormData);

      setBreakdowns(res.json.results);
      setTotalBreakdonws(res.json.count);
    } catch (err) {
      message.error("Something went wrong while fetching patients");
      console.log(err);
    } finally {
      setIsGettingBreakdownPatients(false);
    }
  }

  return (
    <div style={{ padding: "20px 30px" }}>
      <div style={{ fontSize: 20, fontWeight: "600", color: "black", marginBottom: 40, marginTop: 52 }}>Insurance Breakdowns</div>

      <Card style={{ width: "100%" }}>
        <Row gutter={[16, 16]} justify="space-around">
          <InsuranceBreakDownLabel icon={archive} data={`${insuranceStatus.received}`} label="Pending" />
          <InsuranceBreakDownLabel icon={taskSquareWhite} data={`${insuranceStatus.approved}`} label="Approved" />

          <Col xs={24} sm={24} md={24} lg={8}>
            <Input
              value={mySearch}
              onChange={(e) => {
                setMySearch(e.target.value);
              }}
              size="large"
              placeholder="Search Insurance"
              suffix={<img src={search} alt="" />}
              style={{ width: "100%", marginBottom: "16px", height: 52 }}
              className="centered-placeholder"
            />

            <Button
              type="primary"
              size="large"
              block
              style={{ height: 52, display: "flex", alignItems: "center", gap: 5 }}
              onClick={() => setShowRequestModal(true)}
            >
              New Request
              <img src={refresh} alt="refresh" />
            </Button>
          </Col>
        </Row>
      </Card>

      {!isGettingPatients ? (
        <Card style={{ marginTop: 30, padding: "0 10px", position: "relative" }}>
          {/* Filters */}
          {showFilters && (
            <>
              <InsuranceBreakDownFilters
                allPatients={allPatients}
                allProcedures={allProcedures}
                filterFormData={filterFormData}
                setFilterFormData={setFilterFormData}
              />

              <Divider type="horizontal" style={{ backgroundColor: "#B7B7B7" }} />
            </>
          )}

          <Tabs
            defaultActiveKey="all"
            items={insuranceTabs}
            onChange={(key) => {
              setCurrentPage(1);
              setActiveTab(key);
            }}
            size={10}
          />
          <br />
          <Row justify={"center"}>
            <Pagination
              current={currentPage}
              total={totalBreakdowns}
              showSizeChanger={false}
              onChange={(e) => {
                setCurrentPage(e);
              }}
            />
          </Row>

          <Button
            style={{ border: "none", position: "absolute", right: 20, top: 20, height: 40, width: 40 }}
            onClick={() => setShowFilters((show) => !show)}
          >
            <img src={filter} alt="filter" style={{ height: 25, width: 25 }} />
          </Button>
        </Card>
      ) : (
        <div style={{ display: "flex", alignItems: "center", justifyContent: "center", width: "100&", height: "100%", gap: 10 }}>
          <Spin /> Loading
        </div>
      )}

      {/* Requet Modal */}
      <InsuranceBreakDownRequestModal showRequestModal={showRequestModal} setShowRequestModal={setShowRequestModal} setCounter={setCounter} />
    </div>
  );
}
